import React from 'react';
import { StyledTopBar, StyledTopBarContainer, TopBarMain, TopBarVisuallyLeft } from './TopBar.styles';
import ProgramInfo from './ProgramInfo';
import BackButton from '../BackButton';

const TopBar = ({
    title,
    episodeTitle,
    noGradient = false,
    url,
    videos,
    selectedVideoId,
    updateAccessibilityVersion,
    parentUrl,
}) => (
    <StyledTopBarContainer noGradient={noGradient}>
        <StyledTopBar>
            <TopBarVisuallyLeft>
                <BackButton>Tillbaka</BackButton>
            </TopBarVisuallyLeft>
            <TopBarMain>
                <ProgramInfo
                    title={title}
                    episodeTitle={episodeTitle}
                    url={url}
                    videos={videos}
                    selectedVideoId={selectedVideoId}
                    updateAccessibilityVersion={updateAccessibilityVersion}
                    parentUrl={parentUrl}
                />
            </TopBarMain>
        </StyledTopBar>
    </StyledTopBarContainer>
);

export default TopBar;
